<div class="main-content">
  <div class="panel">
    <div class="panel-header">
      <h5 class="fw-bold">Edit Page</h5>
    </div>

    <div class="panel-body">
      <form #pageForm="ngForm" (ngSubmit)="updatePage()">

        <!-- PAGE DETAILS -->
        <div class="card mb-4">
          <div class="card-header fw-bold">
            Page Details
          </div>
          <div class="card-body">

            <!-- Title -->
            <div class="mb-3">
              <label class="form-label">Title*</label>
              <input type="text" class="form-control" name="title" [(ngModel)]="newPage.title" #title="ngModel"
                required>

              @if (title.invalid && title.touched) {
              <div class="text-danger">
                Title is mandatory.
              </div>
              }
            </div>

            <!-- Description -->
            <div class="mb-3">
              <label class="form-label">Description*</label>
              <textarea class="form-control" name="description" [(ngModel)]="newPage.description" #description="ngModel"
                required></textarea>

              @if (description.invalid && description.touched) {
              <div class="text-danger">
                Description is mandatory.
              </div>
              }
            </div>

            <!-- Slug -->
            <div class="mb-3">
              <label class="form-label">Slug*</label>
              <input type="text" class="form-control" name="slug" [(ngModel)]="newPage.slug" #slug="ngModel" required>

              @if (slug.invalid && slug.touched) {
              <div class="text-danger">
                Slug is mandatory.
              </div>
              }
            </div>

            <!-- Page Content -->
            <div class="mb-3">
              <label class="form-label">Page Content</label>
              <!-- <quill-editor name="pageContent" [modules]="modules" [(ngModel)]="newPage.pageContent"></quill-editor> -->

              <!-- <div [ngxSummernote]="options" [(ngModel)]="modules"
                                    [ngModelOptions]="{standalone: true} "></div> -->
            </div>

          </div>
        </div>

        <!-- SEO SECTION -->
        <div class="card mb-4 border-success">
          <div class="card-header bg-success text-white fw-bold">
            SEO Settings
          </div>
          <div class="card-body">

            <!-- Focus Keyphrase -->
            <div class="mb-3">
              <label class="form-label">Focus Keyphrase</label>
              <input type="text" class="form-control" name="keywords" [(ngModel)]="newPage.seoData.keywords">
            </div>

            <!-- SEO Meta Title -->
            <div class="mb-3">
              <label class="form-label">SEO Meta Title</label>
              <input type="text" class="form-control" name="metaTitle" [(ngModel)]="newPage.seoData.metaTitle">
            </div>

            <!-- SEO Meta Description -->
            <div class="mb-3">
              <label class="form-label">SEO Meta Description</label>
              <textarea class="form-control" rows="3" name="metaDescription"
                [(ngModel)]="newPage.seoData.metaDescription"></textarea>
            </div>

          </div>
        </div>

        <!-- SUBMIT -->
        <div class="text-end">
          <button class="btn btn-primary" type="submit" [disabled]="pageForm.invalid">
            Update Page
          </button>
        </div>

      </form>
    </div>
  </div>
</div>